import { LaunchView } from '@/launch/LaunchView';

function Home(): JSX.Element {
  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md w-full rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-lg font-semibold text-gray-900">NameDrop LTI</h1>
        <p className="mt-2 text-sm text-gray-600">
          No active session. Launch from your LMS to continue.
        </p>
      </div>
    </main>
  );
}

export function App(): JSX.Element {
  const path = window.location.pathname;
  const isLaunch = path === '/launch' || path.endsWith('/launch');
  return isLaunch ? <LaunchView /> : <Home />;
}
